import { render, staticRenderFns } from "./ProjectsSelectionView.vue?vue&type=template&id=7fca3bb0&scoped=true"
import script from "./ProjectsSelectionView.vue?vue&type=script&lang=ts"
export * from "./ProjectsSelectionView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fca3bb0",
  null
  
)

export default component.exports